import { useEffect } from "react";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import {  createTheme, ThemeProvider } from '@mui/material/styles';
import colors from "assets/theme/base/colors";
import Button from '@mui/material/Button';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import {Link} from 'react-router-dom';
import workSpace from 'assets/images/illustrations/Google-Workspace-montage.jpg';
import useMediaQuery from '@mui/material/useMediaQuery';

const defaultTheme = createTheme({
    palette: {...colors},
    typography: {
      button: {
        textTransform: 'none'
      },
    },
    img: {
        filter: "brightness(50%)",
    },
}); 

// Intelligently detecting unauthorized use and access in your business applications
  
export default function Workspace() {
    const isMobile = useMediaQuery((theme) => theme.breakpoints.down('md'));
  
  useEffect(() =>{
    document.title = 'Intelligent Cyber-security for Google Workspace';
    window.scrollTo(0,0)
   })
  return (
    <>
          <Box 
          width="100%"
          bgcolor="grey.900"
          sx={{
              height: isMobile ? '100vh' : '60vh',
              backgroundSize: "cover",
              backgroundPosition: "top",
              display: "grid",
              placeItems: "center",
              background: 'linear-gradient( #000000, #242331)'
          }}
      >
      <Grid container maxWidth="lg" spacing={2} p={2} mt={8} sx={{ minHeight: "350px"}}  justifyContent="center" alignItems="center">
        <Grid item xs={12} p={2} textAlign="center">
          <Typography textAlign="center" sx={{ typography: { xs: 'h4', md: 'h1'}, mt: { xs: 6}}} fontWeight="fontWeightMedium" color="grey.300" >
            AI-Powered Security <br />for Google Workspace.
          </Typography>
          <Box sx={{ maxWidth: isMobile ? '90%' : '60%'}} m="auto">
            <Typography textAlign="center" variant="h5" color="grey.500"  sx={{ typography: { xs: 'body1', md: 'h5'}, mt: { xs: 4, md: 5}, mb: { xs: 4, md: 5}}} fontWeight='medium'>
              Detect any active threat against your tenant in as little as one minute. Eliminating the need for attack-specific detection.               
            </Typography>    
          </Box>
          <Typography variant="h3" color="warning.main">
            Coming Soon
          </Typography>
          <Link to="/contact-us" >
            <Button 
                sx={{ marginTop: '50px'}}
                id="learnmore-button"
                disableElevation
                color="prevailRed"
                key="learnmore"
                variant="contained" 
                size="lg">
                    <Typography sx={{ fontSize: "1.3em" }} color="grey.300">Contact Us For Availability</Typography>
            </Button>
          </Link>
        </Grid>
        <Grid item xs={0} md={6} >
        
      </Grid>
      </Grid>
    </Box>
     <Box
        minHeight="40rem"
        width="100%"
        variant="gradient"
        sx={{
            backgroundSize: "cover",
            backgroundPosition: "top",
            display: "grid",
            placeItems: "center",
        }}
      >
        <Grid container maxWidth="lg" mb={2} mt={10}>
          <Grid item xs={12} md={4} mt={10} p={1}>


          </Grid>
        </Grid>
      </Box>

   

</>
  );
}


